import { render, staticRenderFns } from "./RegisterPropertyForm.vue?vue&type=template&id=295621b9&scoped=true"
import script from "./RegisterPropertyForm.vue?vue&type=script&lang=js"
export * from "./RegisterPropertyForm.vue?vue&type=script&lang=js"
import style0 from "./RegisterPropertyForm.vue?vue&type=style&index=0&id=295621b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295621b9",
  null
  
)

export default component.exports